module.exports = {
  draftsList: 'List of Deactivations',
  closedList: 'Closed List',
  editImage: {
    title: 'Edit Image',
  },
  header: {
    title: 'Perks',
    buttonCreate: 'Create',
    buttonPublish: 'Publish',
  },
  table: {
    title: {
      index: 'NO',
      show: 'Active',
      title: 'TITLE',
      link: 'DEEP LINK TYPE',
      partner: 'PARTNER',
      status: 'STATUS',
      action: 'ACTION',
    },
    tooltip: {
      edit: 'Edit',
      delete: 'Delete',
      inactive: 'InActive',
      active: 'Active',
    },
    popup: {
      title: 'Confirm',
      okBtn: 'Yes',
      cancelBtn: 'No',
      delete: 'Are you sure to delete this Perk?',
      edit: 'Are you sure to edit this Perk?',
      enable: 'Are you sure you want to enable this Perk?',
      disable: 'Are you sure you want to disable this Perk?',
    },
  },
  form: {
    image3x4: 'Choose an image or drag it here (1x1)',
    imageUpload: '*Upload an image',
    title: 'Title',
    description: 'Description',
    link: 'Link',
    linkType: 'Deep Link Type',
    deepLink: 'Feature App Deep Link',
    subTitle: 'Subtitle',
    countries: 'Countries',
    buttonList: 'Button (All Perks)',
    buttonDetail: 'Button (Perk Details)',
    partner: 'Choose a partner',
    btnUpdateBenefit: 'Update',
    btnCreateBenefit: 'Add',
    updateBenefit: 'Edit Perk',
    createBenefit: 'Add Perk',
    addPartner: 'Add a partner',
  },
  validate: {
    titleBlank: 'Please input title!',
    countryBlank: 'Please select Country',
    partnerBlank: 'Please choose a partner!',
    linkTypeBlank: 'Please choose a deep link type!',
    deepLinkBlank: 'Please choose a app deep link!',
    linkBlank: 'Please input a link!',
    imageBlank: 'Please input an image!',
    buttonList: 'Please input Button (All Perks) text!',
    buttonDetail: 'Please input Button (Perk Details) text!',
  },
  message: {
    error: {
      uploadImage: 'There was an error while uploading the image. Please try again',
      requireUpload: 'Please upload an image',
    },
    success: {
      updateBenefit: 'Perk successfully updated.',
      createBenefit: 'Perk successfully added.',
      deleteBenefit: 'Perk successfully deleted.',
    },
  },
};
